import React, { Fragment, useState } from 'react'
import { PropTypes } from 'prop-types'
import { Form, Disclosure, Textarea, Toasts } from '@deseretbook/react-ui'
import { DeseretBook } from '../../dbcom/api'
import { Logger, formatErrorMessage } from '../../dbcom'
import { withCheckout } from './CheckoutContext'

const logger = new Logger({ context: 'CheckoutAddons' })

/**
 * Optional addon fields for checkout.
 *
 * @returns {function} Component
 */
const CheckoutAddons = ({
  order,
  startLoading,
  stopLoading,
  updateOrder,
  status,
}) => {
  // Gift Message state
  const [giftMessage, setGiftMessage] = useState(order.giftMessage || '')
  const [savingGiftMessage, setSavingGiftMessage] = useState(false)
  const [hasInitialGiftMessage] = React.useState(!!(order.giftMessage && order.giftMessage.length))

  /**
   * Saves the gift message to the order.
   */
  const saveGiftMessage = () => {
    if ((!order.giftMessage && !giftMessage) || order.giftMessage === giftMessage) {
      return
    }

    startLoading(async () => {
      setSavingGiftMessage(true)

      try {
        const updatedOrder = await DeseretBook
          .order(order)
          .update({ giftMessage })

        updateOrder(updatedOrder, false)
        setSavingGiftMessage(false)
        Toasts.success('Gift message saved')
      } catch ({ message, errors }) {
        setSavingGiftMessage(false)
        stopLoading()
        Toasts.danger('Unable to save gift message', formatErrorMessage(message, errors))
        logger.error(`Unable to save gift message: "${formatErrorMessage(message, errors)}"`, { errors, giftMessage, order })
      }
    })
  }

  return (
    <Fragment>
      <Disclosure isOpen={hasInitialGiftMessage}>
        <Disclosure.Header>Add a gift message</Disclosure.Header>
        <Disclosure.Content>
          <Form onSubmit={saveGiftMessage} isSubmitting={savingGiftMessage}>
            <Textarea
              name="giftMessage"
              value={giftMessage}
              onChange={({ target }) => setGiftMessage(target.value.replace(/[\n\r]+/g, ''))}
              onBlur={saveGiftMessage}
              maxLength={240}
              label="Write a message to the recipient."
              disabled={status.isLoading}
              isLoading={savingGiftMessage}
            />
          </Form>
        </Disclosure.Content>
      </Disclosure>
    </Fragment>
  )
}

CheckoutAddons.propTypes = {
  order: PropTypes.shape({
    number: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  }), // private
  status: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.objectOf(PropTypes.bool),
  ])), // private
  updateOrder: PropTypes.func, // private
  startLoading: PropTypes.func, // private
  stopLoading: PropTypes.func, // private
}

CheckoutAddons.defaultProps = {
  order: {},
  status: {},
  updateOrder: () => {},
  startLoading: () => {},
  stopLoading: () => {},
}

export default withCheckout(CheckoutAddons)
